<sc-flex vertical fitHeight stretchContent>

  <sc-dialog-title>
    <sc-dictionary-label
      dictionaryKey="tmc-common.gate-keeping.ui.gate-keeper-control.dialog-find-element-title"></sc-dictionary-label>
  </sc-dialog-title>

  <sc-tab-group noContent (tabChanged)="handleTabChange($event)" >
    <sc-tab iconCss="fa-magnifying-glass" data="QUERY"></sc-tab>
    <sc-tab iconCss="fa-input-text" data="LPR"></sc-tab>
    <sc-tab iconCss="fa-qrcode-read" data="QR"></sc-tab>
  </sc-tab-group>

  <app-gate-keeper-control-find-element-by-query *ngIf="mode === 'QUERY'" [areaGateReference]="data.areaGateReference"
    (selectionChanged)="handleSelection($event)"></app-gate-keeper-control-find-element-by-query>
  <app-gate-keeper-control-find-element-by-lpr *ngIf="mode === 'LPR'" [areaGateReference]="data.areaGateReference"
    (selectionChanged)="handleSelection($event)"></app-gate-keeper-control-find-element-by-lpr>
  <app-gate-keeper-control-find-element-by-qr *ngIf="mode === 'QR'" [areaGateReference]="data.areaGateReference"
    (selectionChanged)="handleSelection($event)"></app-gate-keeper-control-find-element-by-qr>

  <sc-flex-fitting-content vertical>
    <sc-no-data-container [hasData]="candidates?.length > 0" fitHeight>
      <sc-scroll-pane>
        <sc-padding>
          <sc-flex vertical stretchContent [gap]="16">
            <sc-selectable-tile *ngFor="let candidate of candidates" (click)="selectCandidate(candidate)"
              [style]="candidate === selectedCandidate ? 'selected' : 'default'">
              <app-gate-keeper-candidate-details [gateKeepingCandidate]="candidate"></app-gate-keeper-candidate-details>
            </sc-selectable-tile>
          </sc-flex>
        </sc-padding>
      </sc-scroll-pane>
    </sc-no-data-container>
  </sc-flex-fitting-content>

  <sc-padding>
    <sc-flex>
      <sc-content-spacer grow></sc-content-spacer>
      <sc-cancel-button (click)="close()"></sc-cancel-button>
      <sc-content-spacer></sc-content-spacer>
      <sc-confirm-button primary (click)="confirm()" [disabled]="selectedCandidate == null"></sc-confirm-button>
    </sc-flex>
  </sc-padding>

</sc-flex>
